import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'
import ReactPlayer from 'react-player'
import { Carousel } from '../../components'
import Lottie from 'react-lottie';

import splashLogo from '../../assets/images/mambo-splash-logo.svg'
import splashLogoMobile from '../../assets/images/mambo-splash-logo-mobile.svg'
import splashLogoTablet from '../../assets/images/mambo-splash-logo-tablet.svg'
import * as mamboOnline from '../../animation/MAMBO_GLOBE_Home_White.json'

import { media } from '../../styles/utils'
import { container, bgIcon, bgImage, padding, hoverState } from '../../styles/global'
import { ribbon } from '../../styles/colors';

class Splash extends React.Component {

	constructor(props) {
		super(props);
		this.slider = React.createRef();
	}

	state = {
		active: false,
		logoHovering: false
	}

	componentWillMount = () => {
		const { location } = this.props;

		if (location.pathname == '/') {

			if (typeof window !== 'undefined') {
				document.body.style.overflowY = 'hidden'
            }

			this.setState({
				active: true
			})
		}
	}

	toggleAnimation = (active) => {
		this.setState({
			logoHovering: active
		})
	}
	
	getSlides = () => {
		const { data } = this.props;

		const slides = data.acf.slideshow.map((slide, i) => {
			if (slide.media_type == 'image') {
				return (
					<Image
						image={slide.image.sizes.fullwidth}
					/>
				)
			}
	
			if (slide.media_type == 'video') {
				return (
                    <Video 
                        url={`https://${slide.video_url}`}
						controls={false}
						muted={true}
						playing={true}
						loop={true}
						width={'100vw'}
						height={'100vh'}
					/>
				)
			}
		})

		return slides;
	}

	toggleSplash = () => {
		this.setState({
			active: !this.state.active
		})

		document.body.style.overflowY = this.state.active ?  'auto' : 'hidden';
	}
	
	componentDidUpdate = (prevProps, prevState) => {
		if (prevState.active !== this.state.active && this.state.active == true) {
			this.slider.slickPause()
		}
	}

	renderCarousel = () => {
        const { data } = this.props;
		return ( 
			<Carousel
				slides={this.getSlides()}
				ref={this.slider}
				styles={carouselStyles}
				height={'100vh'}
				settings={{
					dots: false,
					infinite: true,
					fade: true,
					speed: 1000,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 400,
					pauseOnHover: false
				}}
			/>
		)
	}
	
	render() {
		const { active } = this.state;
        
		return (
			<Wrapper
				active={active}
			>
				<Container>

					<MamboOnline
						href="https://www.bigw.com.au/search/?text=mambo&category="
						target="_blank"
						onMouseEnter={() => this.toggleAnimation(true)}
						onMouseLeave={() => this.toggleAnimation(false)}
					>
						<Lottie
							options={{
								animationData: mamboOnline,
								autoplay: false,
							}}
							width={'100%'}
							height={'100%'}
							isStopped={!this.state.logoHovering}
						/>
					</MamboOnline>

					<Logo/>

					{this.renderCarousel()}

					<Continue
						onClick={this.toggleSplash}
					>
						Enter Site
					</Continue>

				</Container>
			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	background: black;
	height: 100vh;
	width: 100vw;

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 12;
	opacity: 1;
	transition: opacity 850ms ease-out;

	${props => {
		if (!props.active) return css`
			pointer-events: none;
			opacity: 0;
		`
	}}
`

const Container = styled.div`
	${container}
	padding: 35px 40px 28px;
	position: relative;

	max-width: none;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;

	${media.phone`
		padding: 15px 40px 20px;
	`}
`

const MamboOnline = styled.a`
	background-image: url(${mamboOnline});
	height: 110px;
	width: 136px;
	${bgIcon}
	z-index: 2;

	/* &:hover {
		background-image: url(${mamboOnlineAnimated});
	} */

	${media.phone`
		height: 70px;
		width: 87px;
	`}
`

const Logo = styled.div`
	background-image: url(${splashLogo});
	height: 196px;
	width: calc(100% - 80px);
	max-width: 1360px;
	${bgIcon}
	z-index: 2;

	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	
	${media.tablet`	
		height: 414px;
		background-image: url(${splashLogoTablet});
	`}

	${media.phone`
		height: 196px;
		background-image: url(${splashLogoMobile});
	`}
`

const Continue = styled.div`
	${hoverState}
	font-family: 'Dot Stick';
	font-size: 10px;
	color: #FFFFFF;
	line-height: 62px;
	z-index: 2;
	
	${media.tablet`
		margin-bottom: 48px;
	`}
`

// Slider

const carouselStyles = css`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
`

const slideStyle = css`
	width: 100vw;
	height: 100vh;
`

const Image = styled.div`
	${slideStyle}
    background-image: url(${props => props.image});
    ${bgImage}

    ${props => {
        return props.styles
    }}
`

const Video = styled(ReactPlayer)`
	${slideStyle}

	video {
		object-fit: cover;
	}
`

export default Splash



// WEBPACK FOOTER //
// ./src/components/Splash/Splash.js